

const NikeLogoSvg = () => (
    <svg width="115" height="40" viewBox="0 0 115 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_309_12435)">
            <path d="M12.519 40C9.49452 39.9692 6.55987 38.9676 4.14763 37.1429C3.53187 36.6079 2.94981 36.0354 2.40477 35.4286C1.58063 34.4365 0.941869 33.3042 0.519053 32.0857C-0.571651 27.5227 0.0697571 22.7172 2.31906 18.6C5.14194 13.0595 8.79346 7.98208 13.1476 3.54286C13.9762 2.65714 16.4048 0 16.4333 0C16.3581 0.181794 16.2622 0.354352 16.1476 0.514287C14.6895 2.88571 13.5556 5.44177 12.7762 8.11428C11.6667 11.3217 11.7992 14.8284 13.1476 17.9429C14.1035 19.7483 15.6028 21.2075 17.4333 22.1143C21.6844 23.677 26.3298 23.8075 30.6619 22.4857L72.8048 11.4286L114.262 0.685712L33.8048 34.4857C29.4333 36.3143 28.2905 36.7714 26.2333 37.3429C21.8607 39.0522 17.2137 39.9526 12.519 40Z" fill="black" />
        </g>
        <defs>
            <clipPath id="clip0_309_12435">
                <rect width="114.262" height="40" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default NikeLogoSvg; 
